import React from 'react';
import { Form, Button } from 'react-bootstrap';
import axios from 'axios';

const TradingDashboard = ({ tradingState, setTradingState, currentISTTime, haltTime, setHaltTime, setSuccess, setError, styles }) => {
  return (
    <div style={styles.dataBox} className="shadow">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h4 className="mb-0">Trading Dashboard</h4>
      </div>
      <div className="mb-2">
        <span>Trading State: </span>
        <span
          style={{
            ...styles.statusIndicator,
            backgroundColor: tradingState ? '#28a745' : '#dc3545'
          }}
        ></span>
        <span>{tradingState ? 'Active' : 'Inactive'}</span>
      </div>
      <div className="mb-2">
        <span>Time (IST): </span>
        <span>{currentISTTime.toLocaleTimeString('en-IN', { hour12: true })}</span>
      </div>
      <Form.Group className="mb-3" controlId="haltTime">
        <Form.Label>Halt Time (IST):</Form.Label>
        <Form.Control
          type="time"
          value={haltTime.toTimeString().slice(0, 5)}
          onChange={(e) => {
            const value = e.target.value;
            const [hours, minutes] = value.split(':').map(Number);
            const newHaltTime = new Date(currentISTTime);
            newHaltTime.setHours(hours, minutes, 0, 0);
            setHaltTime(newHaltTime);
            axios.put(`${process.env.REACT_APP_SERVER_URL}/halt-time`, { haltTime: value })
              .then(() => setSuccess(`Halt time updated to ${value} IST`))
              .catch((error) => setError(`Error updating halt time: ${error.response?.data || error.message}`));
          }}
          style={{ width: '130px' }}
        />
      </Form.Group>
      <div className="row g-2">
        <div className="col-6 col-md-2">
          <Button
            variant="success"
            onClick={() => axios.post(`${process.env.REACT_APP_SERVER_URL}/start-trading`)
              .then(() => {
                setSuccess('Trading started');
                setTradingState(true);
              })
              .catch((err) => 
                setError(`Error starting trading: ${err.response?.data || err.message}`)
              )
            }
            className="w-100"
          >
            Start Trading
          </Button>
        </div>
        <div className="col-6 col-md-2">
          <Button
            variant="danger"
            onClick={() => axios.post(`${process.env.REACT_APP_SERVER_URL}/stop-trading`)
              .then(() => {
                setSuccess('Trading stopped');
                setTradingState(false);
              })
              .catch((err) => 
                setError(`Error stopping trading: ${err.response?.data || err.message}`)
              )
            }
            className="w-100"
          >
            Stop Trading
          </Button>
        </div>
      </div>
    </div>
  );
};

export default TradingDashboard;